import React, { FC } from 'react'

import styles from './styles.module.css'
import Error from 'client/icons/notification/Error'
import Info from 'client/icons/notification/Info'
import Warning from 'client/icons/notification/Warning'
import Success from 'client/icons/notification/Success'

const MESSAGE_TYPES = ['info', 'warning', 'success', 'error'] as const
type MessageType = (typeof MESSAGE_TYPES)[number]

interface MessageBoxProps {
  message: string
  type: MessageType
}

const iconMap: Record<MessageType, FC> = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error,
}

const MessageBox: FC<MessageBoxProps> = ({ message, type }) => {
  const messageType = !MESSAGE_TYPES.includes(type) ? 'info' : type
  const Icon = iconMap[messageType]

  return (
    <div className={styles[messageType]} role="note">
      {Icon && <Icon />}
      <p>{message}</p>
    </div>
  )
}

export default MessageBox
